// Chrome Web Store listing for the Beacon extension
export const EXTENSION_STORE_URL = 'https://chromewebstore.google.com/detail/beacon/jhegpccmgelmibbpbjelgakmaajleoko';
